<template>
<div id="ServiceCodeSAIL" >
  <b-modal id="ServiceCodeSAILAddEdit"  style="height:10px"  v-model="showEditModal"  no-close-on-esc no-close-on-backdrop hide-header-close
          ok-variant cancel-variant
          header-class="PopUpHeader" 
          :body-bg-variant=PopUpVar.bodyBgVariant
          :body-text-variant=PopUpVar.bodyTextVariant
          :footer-bg-variant=PopUpVar.footerBgVariant
          :footer-text-variant=PopUpVar.footerTextVariant> 
        <ServiceCodeSAILAddEdit  v-if="showEditModal==true" :UserData="UserData" :UserRow="editedRow" :DataSet="tableData" :mode="mode" @ServiceCodeSAILUpdate="UpdateRecord"></ServiceCodeSAILAddEdit>
        
        <template slot="modal-header"> 
            <div>
            <small class="modal-title PopUpTitle w-100 text-left">{{mode}} SAIL Benefits</small>
          </div> 
          <div v-show="mode=='Edit'"><small class="modal-title w-100 text-right"></small></div>
        </template> 
        <div slot="modal-footer" class="w-100"> 
        </div>
      </b-modal> 

        <div class="row mb-0 ">
            <div class="col-5">
              <label for="VueTables_Adduser" class="VueTables_user small">SAIL Benefits:</label>
            <div slot="beforeBody"  class="VueTables_Adduser small">
                <button :disabled="readonly || maxRows" type="button" v-on:click="AddServiceCodeSAILPopup()" class="btn btn-primary btn-smlb">Add SAIL </button>
            </div>
          </div>
          <div class="col-7 float-left">
              <v-client-table class="small float-left" :columns="columns" :data="tableData" :options="options">
                <span class="pointer" v-on:click="DeleteRecordMsgBox('Are you sure you want to delete this SAIL Benefit?'   ,props)" slot="delete" slot-scope="props" ><i class="far fa-trash-alt"></i></span>
                <span class="pointer" v-on:click="EditServiceCodeSAILPopup(props)" slot="edit" slot-scope="props" ><i class="far fa-edit"></i></span>
              </v-client-table> 
          </div>
        </div>
        </div>
</template>

<script>
import moment from 'moment'
import { PopUpVariant } from '@/Common/Default/PopUpVariant';
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Modal from '../../../Common/ModelPop.vue';
import ServiceCodeSAILAddEdit from '@/components/DPEBB/Administrator/ServiceCodeSAILAddEdit.vue';
const MaxSailCodes = 25
export default {
props:{
      Data:'',
      ReadOnly:false
    },
     data: function(){
        return {
            PopUpVar:PopUpVariant,
            showModal:false,
            isValid:false,
            Access:'',
            AllowAdd:false,
            showEditModal:false,
            isValid:'',
            Button:'',
            readonly:false,
            mode:'',
            maxRows:false,
        columns: ['delete','edit','prerequisite','pctDPPays'],
        tableData: [],
        options: {
          skin:"table-striped table-bordered table-hover",

        texts:{
              count:"Showing {from} to {to} of {count} records|{count} records|One record",
              first:'First',
              last:'Name',
              filter:"",
              limit:"Records:",
              page:"Page:",
              noResults:"No matching records",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns',
            
          }, 
       
          responseAdapter({data}) {
           
              return {
                data: formatData,
                // count: data.length
              };
             
            },
         
          perPage:5,
          perPageValues:[10,15,25],
          dateColumns:['effectivedate','expirydate'],
          toMomentFormat: 'YYYY-MM-DD',
        

          headings: {
            prerequisite: 'Specs Ben',
            pctDPPays: 'Percentage',
            edit:'',
            delete:''
          },
          pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          sortable: ['prerequisite','pctDPPays'],
         filterable: [], 
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
            }       
        }
        
        },
        components: {
          Modal:Modal,
          Card,
          CardBody,
          TileNote,
          ServiceCodeSAILAddEdit
        
        },
        created:function(){
            this.tableData = this.Data;
           this.readonly = this.ReadOnly;
           this.maxRows = this.tableData.length == MaxSailCodes;
        },
        mounted() {
            // hide admin column
            if (this.readonly) {
                  this.columns.splice(this.columns.findIndex(column => column == 'edit'), 1);
        }
    },
    methods:{
      AddServiceCodeSAILPopup(){
        this.editedRow = -1;
        this.mode='Add';
        this.UserData = '';
        this.showEditModal=true;
      },
      EditServiceCodeSAILPopup(Rowdata){
          this.editedRow = Rowdata.index -1;
          this.mode='Edit';
          this.UserData = Rowdata.row
          this.showEditModal=true;
      },
      UpdateRecord(value){
          this.showEditModal = false;
        if(this.editedRow != -1){
          this.tableData[this.editedRow].prerequisite = value.prerequisite;
          this.tableData[this.editedRow].pctDPPays = value.pctDPPays;
        }
        else{
            this.tableData.push({prerequisite: value.prerequisite,pctDPPays: value.pctDPPays});
        }
        
        this.maxRows = this.tableData.length == MaxSailCodes;
      },
       DeleteRecordMsgBox(msg,data){
        this.boxTwo = ''
        this.$bvModal.msgBoxConfirm(msg, {
          title: 'Please Confirm',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          cancelVariant: 'default',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: true,
          centered: true, 
        })
        .then(value => {
          this.boxTwo = value
          var vm = this;
          if(value)
          {
            this.tableData.splice((data.index -1),1);
            this.maxRows = this.tableData.length == MaxSailCodes;
          }
        })
        .catch(err => {
          console.log(err);
        })
      }
    }
}
</script>

<style>
#ServiceCodeSAIL  .modal-dialog {
    max-width: 70%;
    margin: 0;
    top: 5%;
    bottom: 0;
    left: 20%;
    right: 20%;
    height: 35vh;
    display: flex;
    z-index: 100000;
}
</style>

